import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 箱封信息
export function containerList(params) {
  return request({
    url: URL.seaExport.container,
    method: 'get',
    params
  })
}

// 获取装箱列表
export function queryContainersByJobUuid(data) {
  return request({
    url: URL.seaExport.queryContainersByJobUuid,
    method: 'post',
    data
  })
}

// 获取装箱列表
export function queryPoInfoList(data) {
  return request({
    url: URL.seaExport.queryPoInfoList,
    method: 'post',
    data
  })
}

// 移除箱子PO关系
export function removePoInfo(data) {
  return request({
    url: URL.seaExport.removePoInfo,
    method: 'post',
    data
  })
}

// 移除箱子PO关系
export function queryPackageList(data) {
  return request({
    url: URL.seaExport.queryPackageList,
    method: 'post',
    data
  })
}

// 移除箱子PO关系
export function queryGoodsList(data) {
  return request({
    url: URL.seaExport.queryGoodsList,
    method: 'post',
    data
  })
}

// 修改集装箱状态，且清除箱子下对应的其余装箱信息
export function updateContainerState(data) {
  return request({
    url: URL.seaExport.updateContainerState,
    method: 'post',
    data
  })
}

// 清除装箱信息
export function clearContainerPo(data) {
  return request({
    url: URL.seaExport.clearContainerPo,
    method: 'post',
    data
  })
}

// 根据提单UUID查询件毛体
export function queryPoPackageCartonQuantity(data) {
  return request({
    url: URL.seaExport.queryContainerPackageTotalInfo,
    method: 'post',
    data
  })
}

// 获取包装信息，包含包装统计信息
export function queryPoPackageListWithTotalPoPackage(data) {
  return request({
    url: URL.seaExport.queryPoPackageListWithTotalPoPackage,
    method: 'post',
    data
  })
}

// 获取包装信息，包含包装统计信息
export function batchRemoveEdiContainerPackage(data) {
  return request({
    url: URL.seaExport.batchRemoveEdiContainerPackage,
    method: 'post',
    data
  })
}

// 保存件毛体数据
export function savePackageInfo(data) {
  return request({
    url: URL.seaExport.savePackageInfo,
    method: 'post',
    data
  })
}

// 获取包装信息，包含包装统计信息
export function queryPoPackageListWithHblNo(data) {
  return request({
    url: URL.seaExport.queryPoPackageListWithHblNo,
    method: 'post',
    data
  })
}

// 批量添加拆单箱子包装关系信息
export function batchAddEdiContainerPackage(data) {
  return request({
    url: URL.seaExport.batchAddEdiContainerPackage,
    method: 'post',
    data
  })
}

// 获取和业务箱子绑定的PO订单
export function queryOrderListByContainer(data) {
  return request({
    url: URL.seaExport.queryOrderListByContainer,
    method: 'post',
    data
  })
}

// 获取和业务箱子绑定的PO订单
export function queryOrderListByContainerCargoDoc(data) {
  return request({
    url: URL.seaExport.queryOrderListByContainerCargoDoc,
    method: 'post',
    data
  })
}

// 获取和业务箱子绑定的PO订单 Console模式
export function queryOrderListByConsoleContainer(data) {
  return request({
    url: URL.seaExport.queryOrderListByConsoleContainer,
    method: 'post',
    data
  })
}
// 批量添加拆单和箱子PO订单关系信息
export function batchModifyEdiContainerPoInfo(data) {
  return request({
    url: URL.seaExport.batchModifyEdiContainerPoInfo,
    method: 'post',
    data
  })
}

// 导出装箱计划excel
export function exportCabinetListExcelFile(data) {
  return request({
    url: URL.seaExport.exportCabinetListExcelFile,
    method: 'post',
    data
  })
}

// 导出Loading List
export function exportLoadingListExcelFile(data) {
  return request({
    url: URL.seaExport.exportLoadingListExcelFile,
    method: 'post',
    data
  })
}

// 导出PACK SLIP FOR FCL
export function exportPackSlipForFCLListExcelFile(data) {
  return request({
    url: URL.seaExport.exportPackSlipForFCLListExcelFile,
    method: 'post',
    data
  })
}

// 海运出口导出FclShipmentReport
export function exportFclShipmentReportExcel(data) {
  return request({
    url: URL.seaExport.exportFclShipmentReportExcel,
    method: 'post',
    data
  })
}

// 海运出口导出WarehouseFee 仓储费
export function exportWarehouseFee(data) {
  return request({
    url: URL.seaExport.exportWarehouseFee,
    method: 'post',
    data
  })
}

// 海运出口导出Shipment Report/Weekly Loading Plan
export function exportPoExcel(data) {
  return request({
    url: URL.seaExport.exportPoExcel,
    method: 'post',
    data
  })
}

// 海运出口导出PACK SLIP
export function exportPackSlipExcel(data) {
  return request({
    url: URL.seaExport.exportPackSlipExcel,
    method: 'post',
    data
  })
}

export function xhqSendLCLList(data) {
  return request({
    url: URL.seaExport.xhqSendLCLList,
    method: 'post',
    data
  })
}

export function xhqCheckMultCustoms(data) {
  return request({
    url: URL.seaExport.xhqCheckMultCustoms,
    method: 'post',
    data
  })
}
